import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, requireAdmin = false, requireEmployee = false }) => {
  const { user, loading, isAuthenticated, isAdmin, isEmployee } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/employee" replace />;
  }

  if (requireEmployee && !isEmployee) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default ProtectedRoute;